import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";

export const season = type => {
  return (
    <div className="container">
      {breadcrumbs(type, [{ href: "/voice2/", text: "お客様の声" }, { text: "季節外用品・育児用品の収納に" }])}
      
      <div className="season">
        <h1 id="useCaseContentsHead"><span>季節外用品・育児用品の収納に</span></h1>
        <div className="useCaseImg"><img src="resource/img/static/voice2/season/kv_02.jpg" alt="活用事例"/></div>
          <div id="useCaseVoiceArea">           
            <div className="useCaseBox">
              <h2>衣替えの際に大活躍！！</h2>
              <div className="useCaseBoxInfo">
                <p className="useCaseName">家族が多いS様</p>
                <p className="useCaseText">
                  毎年、衣替えの季節に悩まされていたのが、服の収納場所でした。私の家は子供が二人、両親も健在で、六人で生活しているため服の量も比例して多いため、収納は一苦労です。ましてや、子供が年頃なため、次から次へと洋服が増えていって押入れが悲鳴をあげ始めたころ、トランクルームの利用を始めました。おかげでクローゼットは広くなり、たまにその辺に落ちている洋服たちも最近は減ってきました。
                </p>
              </div>
            </div>
            
          <div className="useCaseBox">
            <h2>子供の五月人形をしまえてスッキリ！</h2>
            <div className="useCaseBoxInfo">
              <p className="useCaseName">小さなお子様がいるK様</p>
              <p className="useCaseText">
                子供の五月人形を毎年飾っているのですが、毎年「どこにいったんだろう？」と押入れの中を探すところから始めていました。また、見つかっても押入れの中の奥の方にあり、大きさもあるためなかなか出しづらいと感じておりました。そんな時に、トランクルームに入れてしまおうと思い、利用し始めました。利用後は、人形を探す手間もなくなり、押入れも広くなったので、とても満足です。
              </p>
            </div>
          </div>
            
          <div className="useCaseBox">
            <h2>次の子供のための育児用品を収納</h2>
            <div className="useCaseBoxInfo">
              <p className="useCaseName">赤ちゃんがいるM様</p>
              <p className="useCaseText">
                子供が大きくなるにつれて、洋服や遊ぶおもちゃなどをよく買っていたら、いつの間に育児用品がいっぱいになっておりました。（苦笑）正直、子供は一人だけとは思っていませんし、かと言って次生まれてくる子供にまた一から買う気にもなれなかったため、それまでの間の収納としてトランクルームを借りました。トランクルームというと大きいものを想像していたのですが、ちょっとしたクローゼット位の大きさもあったので、そちらを利用させてもらっています。
              </p>
            </div>
          </div>
            
          <div className="useCaseBox">
            <h2>アウトドア用品の置き場所に</h2>
            <div className="useCaseBoxInfo">
              <p className="useCaseName">アウトドア好きなT様</p>
              <p className="useCaseText">
                毎年、夏に家族でキャンプに出掛けるのが楽しみで、新しいアウトドア用品を買い足していった結果、収納に困りました。（苦笑）使い古したものなどは、思い切って処分することも考えましたが、思い入れがあるため結局、捨てられずトランクルームにお世話になるようになりました。空調が行き届いているので安心して収納できるし、盗難や天候などによる汚れもないし、駐車場が完備されているので駐車違反を気にしなくてゆっくりと荷物の出し入れができるのもとても助かっています。
              </p>
            </div>
          </div>  
        </div>

        <div id="pageTopAreaBottom">&nbsp;</div>

        <div id="useCaseContentsLink">
          <h2>その他の活用事例</h2>
          <ul>
            <li><a href="/voice2/moving/"><img src="resource/img/static/voice2/season/use_case_01.jpg" alt=""/><span>詳細はこちら</span></a><div className="useCaseContentsLinkBtn"><a href="/voice2/moving/"><span>引越し・リフォームの際の一時収納に</span></a></div></li>
            <li><a href="/voice2/season/"><img src="resource/img/static/voice2/season/use_case_02.jpg" alt=""/><span>詳細はこちら</span></a><div className="useCaseContentsLinkBtn"><a href="/voice2/season/"><span>季節外用品・育児用品の収納に</span></a></div></li>
            <li><a href="/voice2/hobby/"><img src="resource/img/static/voice2/season/use_case_03.jpg" alt=""/><span>詳細はこちら</span></a><div className="useCaseContentsLinkBtn"><a href="/voice2/hobby/"><span>趣味・コレクションの収納に</span></a></div></li>
            <li><a href="/voice2/organization/"><img src="resource/img/static/voice2/season/use_case_04.jpg" alt=""/><span>詳細はこちら</span></a><div className="useCaseContentsLinkBtn"><a href="/voice2/organization/"><span>法人・団体の荷物収納に</span></a></div></li>
          </ul>
        </div>
        <p className="useCaseTextLink"><a href="/voice2/">⇒ お客様の声をみる</a></p>

        <div id="useCasePrefecturalLink">
          <a href="/">
            <div id="useCasePrefecturalLinkTitle"><img src="resource/img/static/voice2/season/use_case_cv_area_copy.png" alt=""/></div>
            <div id="useCasePrefecturalLinkButton">近くのトランクルームを探す</div>
          </a>
        </div>
      </div>
    </div >
  );
};



// WEBPACK FOOTER //
// ./pages/new/season.jsx